import { render, staticRenderFns } from "./myGoods.vue?vue&type=template&id=26da29d2&scoped=true&"
import script from "./myGoods.vue?vue&type=script&lang=js&"
export * from "./myGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26da29d2",
  null
  
)

export default component.exports